import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';
import { ReactNode } from 'react';

interface FooterProps {
  className?: string;
  children: ReactNode;
}

export const Footer = ({ children, className }: FooterProps) => {
  return (
    <section className={flattenClassNames(['row-start-3 row-end-3', className])}>
      {children}
    </section>
  );
};
